import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=dff07528&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
import style0 from "./Add.vue?vue&type=style&index=0&id=dff07528&prod&lang=scss&scoped=true"
import style1 from "./Add.vue?vue&type=style&index=1&id=dff07528&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff07528",
  null
  
)

export default component.exports